<template>
  <div class="abilityPage" >
    <h-page-container class="container">
      <!-- 展示能力细节 -->
       <div class="breakcrumbStyle" v-if="isDetail">
          <h-page-header slot="pageHeader" style="height: 42px;"  return-router="/abilityInfo" :breadcrumb="breadcrumb" return-icon/>
      </div>

      <div class="abilityInfoBox">
        <div class="abilityImgLeft">
        <img v-if="abilityInfo.ico" :src="abilityInfo.ico" />
        <h-empty v-else style="background: #efefef">
          <template #img>
            <h-empty-default-image />
          </template>
        </h-empty>
        </div>
        <div class="abilityInfoRight">
          <h1 v-html="abilityInfo.abilityName" style="height: 25px"></h1>
          <div class="abilityDetailInfo">
            <span class="label">{{$t('ability.descriptionA')}}</span>
            <span>&nbsp;&nbsp;</span>
            <span class="text" :title= abilityInfo.description ref="descC">{{ abilityInfo.description }}</span>
          </div>
          <div class="abilityDetailInfo">
            <span class="label"  style="width: 70px;">{{$t('ability.scnen')}}</span>
            <span>&nbsp;&nbsp;</span>
            <span class="text">{{ abilityInfo.applicableScene }}</span>
          </div>
            <div class="abilityDetailInfo">
            <span class="label"  style="width: 70px;">{{$t('ability.openModels')}}</span>
            <span>&nbsp;&nbsp;</span>
            <span class="openText">
              <el-tag v-if="isShowOpemModel" v-for="tag in currOpenModel" type="success">{{ tag.label }} </el-tag>
            </span>
          </div>
        </div>
      </div>

      <!-- <div class="tabClick"> -->
        <h-affix :offset-top="110">
          <div class="tabClick">
            <h-layout-header>
            <el-tabs v-model="activeTab" @tab-click="handleClick">
              <el-tab-pane v-for="item in currOpenModel"
                :key= "item.value"
                :label= "item.label"
                :name= "item.value"
              ></el-tab-pane>
            </el-tabs>
            </h-layout-header>
          </div>
        </h-affix>
      <!-- </div> -->
      <div class="showDetail">
        <div class="tableAndAnchor" v-loading="loading" :element-loading-text="$t('ability.loading')">
          <h-affix :offset-top="150">
            <div class="showGroup" v-if="isApiPage">
              <h-page-sidebar type="list" width="180px">
                <ul>
                  <li
                    v-ellipsis
                    v-for="(item, index) in groupInfo"
                    :key="index"
                    :class="{ active: item.id === activeSidebar }"
                    @click="getApiInfoList(item.id)"
                  >
                    <span>{{ item.label }}</span>
                  </li>
                </ul>
              </h-page-sidebar>
            </div>
          </h-affix>
          <div class="tableDetail" v-if="isApiPage">
              <template>
                <el-table
                  ref="apiTable"
                  :data="apis"
                  stripe
                  >
                  <el-table-column
                    type="index"
                    width="30">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('document.ApiName')">
                    <template slot-scope="scope">
                      <a :href="scope.row.hrefId" >{{scope.row.name}}</a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="description"
                    :label="$t('document.description')" min-width="200">
                    <template slot-scope="scope">
                      <div v-html="scope.row.description" @click="apiJ"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="id"
                    :label="$t('document.apiDown')">
                    <template slot-scope="scope">
                      <a :href="`/artemis-portal/artemis/getApiDocxById/${scope.row.id}`">{{$t('document.apiDown')}}</a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="minVersion"
                    :label="$t('document.versionSuptStart')">
                  </el-table-column>
                  <el-table-column
                    prop="maxVersion"
                    :label="$t('document.versionSuptEnd')">
                  </el-table-column>
                </el-table>
              </template>
          </div>
          <div v-if="isApiPage" class="showAnchor">
              <h-anchor :offset-top="150" show-ink>
                <div v-for="(apia, index) in apis" :key="index">
                  <h-anchor-link :href="apia.hrefId" :title="apia.name" style="width:270px" />
                </div>
              </h-anchor>
          </div>
          <div v-else class="showAnchor">
              <h-anchor :offset-top="150" show-ink :affix='false' :scroll-offset="80" >
                <div v-for="(doc, i) in docList" :key="i">
                  <h-anchor-link :href="doc.hrefId" :title="doc.title" style="width:270px"/>
                </div>
              </h-anchor>
           </div>
        </div>
            <div class="resourceDetail" v-if="isApiPage" v-for="(api, index) in apis" :key="index">
              <h2 style="margin-top: 20px" :id="api.id">
                <a :href="api.herfName" aria-hidden="true" class="header-anchor" style="display: none">#</a>
                {{index+1}}.{{api.name}}
              </h2>
              <ul>
                <li>
                  <div class="baseTitleStyle">
                    <h3 style="margin-left:5px">{{$t('document.basicInfo')}}</h3>
                  </div>
                  <div>
                    <div class="baseLineTitleStyle">{{$t('document.descriptionNew')}}</div>
                    <p class="baseLineStyle" v-html="api.description"  @click="apiJ"></p>
                  </div>
                  <div>
                    <div class="baseLineTitleStyle" >{{$t('document.groupC')}}</div>
                    <p class="baseLineStyle">{{api.group.name}}</p>
                  </div>

                  <div>
                    <div class="baseLineTitleStyle" >{{$t('document.versionSuptC')}}</div>
                    <p class="baseLineStyle">{{api.minVersion}}</p>
                  </div>
                </li>
                <li>
                  <div class="baseTitleStyle">
                    <h3 style="margin-left:5px">{{$t('document.BaseicRequest')}}</h3>
                  </div>

                   <div>
                    <div class="baseLineTitleStyle" >{{$t('document.protocolC')}}</div>
                    <p class="baseLineStyle">{{api.protocol}}</p>
                  </div>
                   <div>
                    <div class="baseLineTitleStyle" >{{$t('document.hostPath')}}</div>
                    <p class="baseLineStyle">{{hostPath}}{{api.path}}</p>
                  </div>
                   <div>
                    <div class="baseLineTitleStyle" >HTTP METHOD：</div>
                    <p class="baseLineStyle">{{api.httpMethod}}</p>
                  </div>
                   <div>
                    <div class="baseLineTitleStyle" >{{$t('document.securityVerificationC')}}</div>
                    <p class="baseLineStyle">{{$t('document.APIGatewaySV')}}</p>
                  </div>

                </li>
                <li>
                  <div class="baseTitleStyle">
                    <h3 style="margin-left:5px">{{$t('document.requestDefinition')}}</h3>
                  </div>
                  <div v-if="api.inputParams.length" class="tableScroll" style=" margin-left:20px;margin-top:10px">
                    <div class="table-margin">
                      <template>
                        <el-table
                          ref="oneapi"
                          :data="api.inputParams"
                          stripe
                          style="width: 99%">
                          <el-table-column
                            type="index">
                          </el-table-column>
                          <el-table-column prop="model.name" :label="$t('document.paramName')">
                            <template slot-scope="scope">
                                <span :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.name}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="position" :label="$t('document.paramLocation')">
                          </el-table-column>
                          <el-table-column prop="model.type" :label="$t('document.type')">
                          </el-table-column>
                          <el-table-column prop="model.required" :label="$t('document.required')">
                                <template slot-scope="scope">
                                  <i :class="[scope.row.required ? 'h-icon-tip_right' : 'h-icon-tip_error']" style="font-size: 22px;"></i>
                              </template>
                          </el-table-column>
                          <el-table-column
                            prop="model.description"
                            :label="$t('document.description')">
                            <template slot-scope="scope">
                              <div v-html="scope.row.description" @click="apiJ"></div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="example" :label="$t('document.examples')"></el-table-column>
                        </el-table>
                      </template>
                    </div>
                  </div>
                  <p class="baseLineTitleStyle" v-else>{{$t('document.null')}}</p>
                </li>
                <li v-if="api.inBody">
                  <div class="baseTitleStyle">
                    <h3 style="margin-left:5px">{{$t('document.requestBodyDefin')}}</h3>
                  </div>
                   <div>
                    <div class="baseLineTitleStyle" >{{$t('document.securityVerificationC')}}</div>
                    <p class="baseLineStyle">{{api.inBody.contentType}}</p>
                  </div>
                  <div>
                    <div class="baseLineTitleStyle" >{{$t('document.descriptionC')}}</div>
                  </div>

                  <div class="table-margin" style="margin-left:20px;margin-top:10px">
                    <template>
                      <el-table
                          ref="oneapiinbody"
                          :data="api.inBody.children"
                          stripe
                          style="width: 99%">
                          <el-table-column
                            type="index">
                          </el-table-column>
                          <el-table-column prop="name" :label="$t('document.fieldName')">
                            <template slot-scope="scope">
                                <span :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.name}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="type" :label="$t('document.type')">
                          </el-table-column>
                          <el-table-column prop="model.required" :label="$t('document.required')">
                                <template slot-scope="scope">
                                  <i :class="[scope.row.required ? 'h-icon-tip_right' : 'h-icon-tip_error']" style="font-size: 22px;"></i>
                              </template>
                          </el-table-column>
                          <el-table-column
                            prop="description"
                            :label="$t('document.description')" min-width="160">
                            <template slot-scope="scope">
                              <div v-html="scope.row.description" @click="apiJ"></div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="example" :label="$t('document.examples')"></el-table-column>
                      </el-table>
                    </template>
                  </div>
                  <p class="baseLineTitleStyle">{{$t('document.examplesC')}}</p>

                  <!-- <json-viewer style="margin-left:20px;margin-right:10px"
                    :value= api.inBody.demo
                    :expand-depth=3
                    :copyable="copyJson"
                  ></json-viewer> -->
                  <div class="example-container" :title="api.inBody.demo" style="margin-left:20px;margin-right:10px">
                    <pre class="json-pre">{{api.inBody.demo}}</pre>
                  </div>
                </li>
                <li>
                  <div class="baseTitleStyle">
                    <h3 style="margin-left:5px">{{$t('document.responseResult')}}</h3>
                  </div>

                   <div>
                    <div class="baseLineTitleStyle" >{{$t('document.responseTypeC')}}</div>
                    <p class="baseLineStyle"><span data-parse="result-type">{{api.response.contentType}}</span></p>
                  </div>
                  <div>
                    <div class="baseLineTitleStyle" >{{$t('document.responseDesC')}}</div>
                  </div>
                  <div class="table-margin" style="margin-left:20px;margin-top:10px">
                    <template>
                      <el-table
                          ref="oneapirespon"
                          :data="api.response.children"
                          stripe
                          style="width: 99%">
                          <el-table-column
                            type="index"
                            width="30">
                          </el-table-column>
                          <el-table-column prop="mappingName" :label="$t('document.fieldName')">
                            <template slot-scope="scope">
                                <span v-if='scope.row.mappingName' :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.mappingName}}</span>
                                <span v-else :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.name}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="type" :label="$t('document.type')">
                          </el-table-column>
                          <el-table-column prop="required" :label="$t('document.required')">
                              <template slot-scope="scope">
                                <i :class="[scope.row.required ? 'h-icon-tip_right' : 'h-icon-tip_error']" style="font-size: 22px;"></i>
                              </template>
                          </el-table-column>
                          <el-table-column prop="description" :label="$t('document.description')">
                            <template slot-scope="scope">
                              <div v-html="scope.row.description" @click="apiJ"></div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="example" :label="$t('document.examples')"></el-table-column>
                      </el-table>
                    </template>
                  </div>
                  <div>
                    <div class="baseLineTitleStyle" >{{$t('document.responseExampleC')}}</div>
                  </div>
                  <div class="tableScroll example-container" :title="api.response.resDemo" style="margin-left:20px;margin-right:10px">
                    <pre class="json-pre">{{api.response.example}}</pre>
                  </div>
                 <!-- <json-viewer style="margin-left:20px;margin-right:10px"
                    :value= api.response.example
                    :expand-depth=3
                    :copyable="copyJson"
                    ></json-viewer> -->

                </li>
                <li>
                  <div class="baseTitleStyle">
                    <h3 style="margin-left:5px">{{$t('document.onlineDebug')}}</h3>
                  </div>
                  <p class="btn-p">
                    <el-button :plain="true" class="debug-online-btn noline" target="_blank" type="primary" @click="jumpToWeb(`/artemis-web/debug/${api.id}`)">{{$t('document.DebugIng')}}</el-button>
                  </p>
                </li>
              </ul>
              <hr :id="`api${index+2}`">
            </div>
            <!-- 展示资源信息，主要是文档与下载项 -->
            <div class="resourceDetail" v-if="!isApiPage">
              <div v-if="map.html">
                <!-- <h1 v-text="map.title" class="font24"></h1> -->
                <div v-html="map.html"  @click="apiJ" class="font14"></div>
              </div>
              <div v-else>
                <div v-if="sceneAbilityList.length === 0" style="margin-top: 150px; margin-left:400px; width: 204px; height: 204px">
                  <h-empty :description="$t('h.common.noData')" />
                </div>
              </div>
            </div>
          <!-- </div> -->
      </div>
    </h-page-container>

  </div>
</template>
<script>
import {
  getSceneById,
  getApiInfoByIds,
  getApiGroupDoc,
  getApiByGroupId,
  getDocByGroupId,
  getAbilitResourceList,
  getGroupList,
  getDocByName,
  getApiIdsByAIdAndGroupId,
} from "@/api";
import tableData from "@/components/tableData/tableData";
export default {
  name: "abilityDetail",

  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
    typeCN: {
      type: String,
      default: "",
    },
    typeEN: {
      type: String,
      default: "",
    },
    businessFirstLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //api接口展示相关字段
      isDetail: false,
      path: [
        {
          id: "",
          title: "",
        },
      ],
      sceneDescription: "",
      hostPath: "",
      isApiPage: true,
      //资源展示
      map: {
        title: "",
        html: "",
      },
      breadcrumbSelectedData: [],
      //总的资源列表
      resourceList: [],
      //当前选择的资源列表
      currResourceList: [],
      activeTab: "",
      openModels: [
        {
          value: "api",
          label: "API",
        },
        {
          value: "mq",
          label: this.$t('ability.mq'),
        },
        {
          value: "protocol",
          label: this.$t('ability.protocol'),
        },
        {
          value: "sdk&tool",
          label: this.$t('ability.sdk'),
        },
        {
          value: "resourcePack",
          label: this.$t('ability.resourcePack'),
        },
      ],
      currOpenModel: [],
      isShowOpemModel: false,
      docAnchorList: {
        title: "",
        anchorList: [],
      },
      docList: [],
      isgetDocTitile: false,
      pageState: "list",
      //能力展示相关参数
      sceneAbilityList: [],
      abilityInfo: "",
      apis: [],
      breadcrumb: [ this.$t('ability.list'), this.$t('ability.detail')],
      groupInfo: [],
      activeSidebar: '',
      loading: false,
      copyJson: {
        copyText: this.$t('ability.json.copy'),
        copiedText: this.$t('ability.json.copied'),
        timeout:300
      }
    };
  },
  watch: {
  },
  computed: {},
  created() {},
  mounted() {
    this.getSceneAbilityInfo(this.$route.query.id)
    //设置当前背景色
    // document.querySelector('abilityPage').setAttribute('style', 'background-color:rgb(235, 233, 233)')
  },
  methods: {
    //根据id获取应用场景详细信息
    getSceneAbilityInfo(param) {
      let me = this;
      me.currOpenModel = [];
      me.isShowOpemModel = true;
      const req = {
        id: param,
      };
      me.isDetail = true;
      me.loading = true;

      getSceneById(req)
        .then(function (response) {
          if (response.data.code === "0") {
            me.abilityInfo = response.data.data;
            // me.abilityInfo.ico = require("../img/img02.jpg");
            me.sceneDescription = me.abilityInfo.description;
            let opemWays = me.abilityInfo.openModel.split(",");
            opemWays.forEach(function (item, index) {
              me.currOpenModel.push(
                me.openModels.filter((openModel) => {
                  return openModel.value.indexOf(item) > -1;
                })[0]
              );
            });
            me.activeTab = me.currOpenModel[0].value;

            let ids = me.abilityInfo.apiGroupIds;
            if(ids != null && ids.length != 0) {
               me.isApiPage = true;
               me.getGroupListByIds(ids);
            } else {
              me.isApiPage = false
            }
            //获取其他资源信息
            let id = me.abilityInfo.id;
            if (id != null && id != "") {
              me.isDetail = true;
              me.getResourceByIds(id);
            } else {
              me.resourceList = [];
            }
          } else {
            me.$message.error(
              me.$t(errorCodeKey(response.data.code)),
              me.$t("document.requestFail"),
              me.loading = false
            );
          }
        })
        .catch(function () {
          me.$message.error(me.$t("document.requestFail"));
        });
    },

    getResourceByIds(id) {
      const me = this;
      const reqnew = {
        id: id,
      };
      me.map = {};
      me.docList = [];
      getAbilitResourceList(reqnew)
        .then(function (response) {
          if (response.data.code === "0") {
            me.resourceList = response.data.data.list;
            me.sleep(800)
            if (me.resourceList.length == 0) {

              me.loading = false
              return;
            }
            me.map = {
              title: me.resourceList[0].resourceName,
              html: me.resourceList[0].htmlContent,
            };
            me.sceneAbilityList.push(me.map);
             me.loading = false
          }
        })
        .catch(function () {
          me.$message.error(me.$t("document.requestFail"));
        });
    },
   getGroupListByIds(data){
      const me = this;
      getGroupList(data)
        .then(function (response) {
          if (response.data.code === "0") {
            let apiGroupInfoList = response.data.data.list;
            if (apiGroupInfoList.length == 0) {
               me.loading = false
              return;
            }
            for(var item of apiGroupInfoList) {
              var group = {
                label : item.name,
                id: item.id
              }
              me.groupInfo.push(group)
            }
            me.getApiInfoList()
          }
        })
        .catch(function () {
          me.$message.error(me.$t("document.requestFail"));
        });
    },

    sleep(n) {
        var start = new Date().getTime();
        //  console.log('休眠前：' + start);
        while (true) {
            if (new Date().getTime() - start > n) {
                break;
            }
        }
        // console.log('休眠后：' + new Date().getTime());
    },

     getApiInfoList(data) {
      const me = this
      var aId = me.abilityInfo.id;
      var gId  = ''
      if(data === '' || data == null) {
        me.activeSidebar=me.groupInfo[0].id
        gId = me.activeSidebar
      } else{
        gId = data
        me.activeSidebar = data
      }

      getApiIdsByAIdAndGroupId(aId, gId)
        .then(function(response) {
          if (response.data.code === "0") {
            let apiIds = response.data.data.list;
            if(apiIds == '' || apiIds.length == 0) {
              return
            }
            me.getApiInfoById(apiIds)
             me.loading = false
          }
        })
        .catch(function(){
          me.$message.error(me.$t("document.requestFail"));
        })
    },

    getApiInfoById(ids) {
      const me = this;
      const reqnew = {
        ids: ids,
      };
      getApiInfoByIds(reqnew)
        .then(function (apiResponse) {
          if (apiResponse.data.code === "0") {
            me.apis = me.initGroupApiData(apiResponse.data.data.list);
          }
        })
        .catch(function () {
          me.$message.error(me.$t("document.requestFail"));
        });
    },
    handleClick(value) {
      const me = this;
      if (value.name == "api") {
        me.isApiPage = true;

      } else if (value.name == "sdk&tool") {
        me.isApiPage = false;
        for (let r of me.resourceList) {
          if (r.resourceType == "sdk&tool") {
            me.setPageParam(r);
          }
        }
      } else if (value.name == "mq") {
        me.isApiPage = false;
        for (let r of me.resourceList) {
          if (r.resourceType == "mq") {
            me.setPageParam(r);
          }
        }
      } else if (value.name == "protocol") {
        me.isApiPage = false;
        for (let r of me.resourceList) {
          if (r.resourceType == "protocol") {
            me.setPageParam(r);
          }
        }
      } else if (value.name == "resourcePack") {
        me.isApiPage = false;
        for (let r of me.resourceList) {
          if (r.resourceType == "resourcePack") {
            me.setPageParam(r);
          }
        }
      }
    },
    setPageParam(data) {
      this.map = "";
      this.currResourceList = [];
      this.docList = [];
      //获取htmlContent中的标题，作为右侧锚点
      this.map = {
        title: data.resourceName,
        html: data.htmlContent,
      };
      this.currResourceList.push(data);

      setInterval(() => {
        this.getContetnTitle(data);
      }, 200);
    },
    async getContetnTitle() {
      const me = this;
      me.isgetDocTitile = true;
      let docTag = document.getElementsByTagName("h2");
      me.docList = [];
      if (docTag.length) {
        for (let d = 0; d < docTag.length; d++) {
          let dAdd = d + 1;
          let dClassName = "doc" + dAdd;
          let docc = {};
          docc.title = docTag[d].innerText;
          let ahtml =
            '<a :href="#' +
            docc.title +
            '" aria-hidden="true" class="header-anchor" style="display: none">#</a>';
          docTag[d].innerHTML = ahtml + docTag[d].innerHTML;
          docTag[d].id = dClassName;
          docc.hrefId = "#" + dClassName;
          me.docList.push(docc);
        }
      }
    },

    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    prev() {
      this.isDetail = false;
      this.isShowOpemModel = false;
    },
    getApiGroupDoc(param) {
      this.downloading = true;
      try {
        getApiGroupDoc(param).then(({ data }) => {
          try {
            downloadFile(
              data,
              this.path[this.path.length - 1]["title"] + ".docx"
            );
            this.downloading = false;
          } catch (err) {
            console.error(err);
            this.downloading = false;
          }
        });
      } catch (err) {
        console.error(err);
      }
    },
    apiJ: function (e) {
      const me = this;
      if (e.target.className == "apitt") {
        //获取api
        const apiName = e.target.innerText;
        let currPageApiNameList = me.apis.map(obj => {
          return obj.name
        })
        if (currPageApiNameList.indexOf(apiName) != -1) {
          var currParam = window.location.search
          var currApi = me.apis[currPageApiNameList.indexOf(apiName)].id
          me.$router.push({
            path: '/abilityDetail' + currParam + "#" + currApi,
          });
          return;
        }
        let params = {
          pageNo: 1, //this.tablePage.pageNo,
          pageSize: 1000, //this.tablePage.pageSize,
          apiName: apiName || "", //this.filter.apiName,
          groupCascadeSearch: true,
        };
        getApiByGroupId(params)
          .then(function (response) {
            if (response.data.code === "0") {
              let apiGroupId = response.data.data.list[0].group.id;
              let apiPid = response.data.data.list[0].group.parentId;
              let apigroupName = response.data.data.list[0].group.name;
              let apiId = response.data.data.list[0].id;
              me.isApiPage = true;
              let par = {
                id: apiGroupId,
              };
              getDocByGroupId(par).then(function (re) {
                if (re.data.code === "0") {
                  let treeid = re.data.data.id;
                  me.$router.push({
                    path: "/document/" + treeid + "#" + apiId,
                  });
                } else {
                  me.$message.error(me.$t("document.requestFail"));
                }
              });
            } else {
              me.$message.error(
                me.$t(errorCodeKey(response.data.code)),
                me.$t("document.requestFail")
              );
            }
          })
          .catch(function () {
            me.$message.error(me.$t("document.requestFail"));
          });
      } else if (e.target.className == "docdd") {
        //获取文档
        let docName = e.target.innerText;
        docName = docName.split("->");
        let params = docName;
        getDocByName(params)
          .then(function (response) {
            if (response.data.code === "0") {
              // let docPid = response.data.data.list[0].parentId;
              let docid = response.data.data.id;
              me.$router.push({ path: "/document/" + docid });
              me.isApiPage = false;
            } else {
              me.$message.error(
                me.$t(errorCodeKey(response.data.code)),
                me.$t("document.requestFail")
              );
            }
          })
          .catch(function () {
            me.$message.error(me.$t("document.requestFail"));
          });
      }
    },
    jumpToWeb(params) {
      var host = window.location.host;
      var protocol = window.location.protocol;
      var port = window.location.port;

      if (host.indexOf(":") != -1) {
        if (protocol == "https:") {
          window.open(protocol + "//" + host + params);
        } else if (protocol == "http:") {
          port = process.env.VUE_APP_ARTEMIS_WEB_PORT;
          host = host.substring(0, host.indexOf(":"));
          window.open(protocol + "//" + host + ":" + port + params);
        }
      } else {
        window.open(protocol + "//" + host + params);
      }
    },
    initGroupApiData(data) {
      const that = this;
      let newData = [];
      for (let t in data) {
        if (data[t].status == "ONLINE") {
          newData.push(data[t]);
        }
      }
      data = newData;
      for (let i in data) {
        let apiData = JSON.stringify(data[i]) || "{}";
        apiData = apiData.replace(
          /#API@/g,
          '【<a class=\\"apitt\\" href=\\"javascript:void(0)\\">'
        );
        apiData = apiData.replace(
          /#DOC@/g,
          '【<a class=\\"docdd\\" href=\\"javascript:void(0)\\">'
        );
        apiData = apiData.replace(/@#/g, "</a>】");
        data[i] = JSON.parse(apiData);
        data[i].herfName = "#" + data[i].name;
        data[i].hrefId = "#" + data[i].id;
        let json = data[i].response.example || "{}";
        if (that.isJSON(json)) {
          json = json.replace(/(^\s*)|(\s*$)/g, "");
          // data[i].response.resDemo = JSON.stringify(JSON.parse(json.replace(/(^\s*)|(\s*$)/g, "")), null, 4);
           data[i].response.example = JSON.stringify(JSON.parse(json), null, 4);
        // data[i].response.example = JSON.parse(json);
          // console.log()
        } else {
          data[i].response.example = "{}";
        }

        let inBody = null;
        let inParams = [];
        for (let j = 0; j < data[i].inputParams.length; j++) {
          let inParm = data[i].inputParams[j];
          if (inParm.position == "Body") {
            inBody = inParm;
          } else {
            if (inParm.model) {
              //如果入参已经有model对象，那么重新修改model.children使其符合table数据格式
              for (let j = 0; j < inParm.model.children.length; j++) {
                inParm.model.children[j] = {
                  model: inParm.model.children[j],
                };
              }
            } else {
              //如果入参没有model对象，那么构造model对象
              inParm.model = {
                name: inParm.paramName || "",
                required: !inParm.nullable || false,
                type: inParm.paramType || "String",
                description: inParm.description || "",
                children: [],
              };
            }
            inParm.children = inParm.model.children;
            if (data[i].inputParams[j].displayInDocument) {
              inParams.push(inParm);
            }
          }
        }

        function sortChildren(arr) {
          if (!arr || !arr.length) {
            return;
          }
          arr.sort((a, b) => {
            return sortByRequiredAndLetter(
              a.required,
              b.required,
              a.name,
              b.name
            );
          });
          arr.forEach((r) => {
            if (r.children) sortChildren(r.children);
          });
        }

        function sortByRequiredAndLetter(r1, r2, n1, n2) {
          n1 = n1.toUpperCase();
          n2 = n2.toUpperCase();
          r1 = Number(r1);
          r2 = Number(r2);
          if (r1 > r2) {
            return -1;
          } else if (r1 < r2) {
            return 1;
          } else {
            return n1 > n2;
          }
        }

        /**
         * 将inParms数组的数据复制至用于显示table的_inParms数组里
         * 由于入参定义表格需要显示enum子节点而后端服务参数不需要，所以用两个数组显示表格数据
         */
        data[i].inputParams = tableData.init(inParams, true);

        if (inBody) {
          if (inBody.model) {
            let nArr = [];
            // for (let r = 0; r < inBody.model.children.length; r++) {
            //   if(inBody.model.children[r].displayInDocument){
            //     nArr.push(inBody.model.children[r])
            //   }
            // }
            inBody.model.children = realHidden(inBody.model.children);
            inBody.children = [inBody.model];
          } else {
            inBody.children = null;
          }

          //排序 required为true排在前面，之后按首字母
          // sortChildren(inBody.children);

          if (inBody.children && inBody.children.length > 0) {
            // tableData.addParent(inBody.children, inBody);
            inBody.children = tableData.init(inBody.children);
          }
          //inBody.demo = inBody.example;
           inBody.demo = JSON.parse(inBody.example);
          inBody.contentType = data[i].contentType;
          data[i].inBody = inBody;

          try {
            data[i].inBody.example = JSON.stringify(
              JSON.parse(data[i].inBody.demo.replace(/(^\s*)|(\s*$)/g, "")),
              null,
              4
            );
          } catch (error) {}
        }
        //返回结果
        const response = data[i].response;
        if (response) {
          if (response.model) {
            //model属性不是一个数组，所以为其构建一个children数组，并将model复制给children[0]，构建一个children循环数组
            response.children = [response.model];
            response.children = hideParam(response.children);
          } else {
            response.children = [];
          }

          //排序 required为true排在前面，之后按首字母
          // sortChildren(response.children);

          if (response.children && response.children.length > 0) {
            // tableData.addParent(response.children, response);
            response.children = tableData.init(response.children);
          }
        }
      }
      function hideParam(data) {
        let newArr = [];
        data.forEach(function (item, index, arr) {
          if (!item.displayInDocument) {
          } else {
            newArr.push(item);
            if (item.children) item.children = hideParam(item.children);
          }
        });
        data = newArr;
        return data;
      }
      function hiddenEmptyObject(data) {
        data.forEach(function (item, index, arr) {
          if (item.type == "Object" || item.type == "Array") {
            if (item.children.length > 0) {
              for (var i = 0; i < item.children.length; i++) {
                realHiddenObj(item.children);
              }
            } else {
              data.splice(idnex, 1);
            }
          }
        });
      }
      function realHidden(data) {
        let newArr = hideParam(data);
        hiddenEmptyObject(newArr);
        return newArr;
      }

      function realHiddenObj(data) {
        for (var j = 0; j < data.length; j++) {
          if (data[j].type != "Object" && data[j].type != "Array") {
            continue;
          } else if (data[j].children.length > 0) {
            realHiddenObj(data[j].children);
          } else {
            data.splice(j, 1);
            j--;
          }
        }
      }
      that.loading = false
      return data;
    },
  },
};
</script>
<style lang="less" scoped>
.h-page-footer__left {
  width: 100%;
}
::v-deep .el-scrollbar {
  height: calc(~"100% - 25px");
}
::v-deep .list-scrollbar-wrap {
  max-height: 100%;
  overflow-x: hidden;
}
.abilityPage{
  min-height: 100%;
  background-color:#f3f5f8;
}
.container{
  display:flex;
  min-height: 100%;
  // background-color:rgb(235, 233, 233);
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity 0.1s 0.15s ease;
}
.slide-fade-leave-active {
  transition: opacity 0.1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  // transform: translateY(-10px);
  opacity: 0;
}

.page-appManege-icon {
  min-width: 24px;
  font-size: 24px;
  vertical-align: middle;
  line-height: 0;
}
.el-pagination {
  text-align: center;
  margin-bottom: auto;
}
.breakcrumbStyle {
  position: fixed;
  height: 42px;
  width: 100%;
  background-color: white;
  z-index: 100;
}
.tabClick {
  background: white;
  // position: fixed;
  z-index: 100;
  margin-left: 200px;
  margin-right: 200px;
  }

.showDetail {
  margin-left: 200px;
  margin-right: 200px;
  min-height: 680px;
  background-color: white;
    .tableAndAnchor{
      display: flex;
      min-height: 100%;
      .showGroup{
        height: calc(100vh - 75%);
        overflow:hidden;
         min-height: 100%;
      }
      .tableDetail{
        background: #fff;
        width: 1100px;
        // margin-left: 180px;
        padding: 10px;
        overflow: hidden;
      }
      .showAnchor {
        // height: calc(100vh - 75%);
        min-height: 100%;
        // margin-right: 10px;
        // max-height: 80%;
      }
    }
    .resourceDetail{
      padding: 10px;
       width: 1000px;
      margin-left: 180px;
      margin-right: 180px;
      background: #fff;
      min-height: 100%;
    }

}
.btn-p {
  margin-top: 5px;
}

.abilityInfoBox {
  display: -webkit-box;
  margin-top: 48px;
  margin-left: 200px;
  margin-right: 200px;
  background-color: white;
  transition: 0.5s;
  margin-bottom: 8px;
  .abilityImgLeft {
    width: 135px;
    height: 135px;
    img {
      margin-top: 5px;
      width: 140px;
      height: 130px;
    }
  }
  .abilityInfoRight {
    margin-left: 18px;
    width: calc(~"50% - 168px");
  }
  .abilityDetailInfo {
    width: 1300px;
  }
  .hide {
    margin-left: 18px;
  }
  .label {
    color: #aeaeae;
    margin-bottom: 6px;
    line-height: 40px;
  }
  .text {
    margin-bottom: -4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 1200px;
    display: inline-block;
    height: 19px;
  }
  .text.fold {
    -webkit-line-clamp: 1;
  }
  .text.unfold {
    -webkit-line-clamp: 100;
  }

  .openText {
    //  white-space: nowrap;
    display: inline-block;
    .el-tag + .el-tag {
      margin-left: 8px;
    }
  }
}

.example-container {
    overflow: auto;
    word-break: break-all;
}
.nodata {
  width: 180px;
  height: 170px;
  align-items:center;
}
.baseLineTitleStyle {
  margin-left:20px;
  margin-top:10px;
  font-weight:bold;
  display:inline-block
}
.baseTitleStyle {
  margin-top:10px;
  border-left: 3px solid #2395f1;
}
.baseLineStyle{
  margin-top:10px;
  display:inline
}
</style>
